import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["track", "thumb"];

  select(e) {
    this.handlePositionUpdate(e.target.dataset.index);
    this.thumbTargets.forEach((element) => {
      element.classList.remove("active");
    });

    e.target.classList.add("active");
  }

  handlePositionUpdate(index) {
    const clientWidth = this.trackTarget.clientWidth;
    const scrollWidth = this.trackTarget.scrollWidth;
    const maxPosition = Math.floor(scrollWidth / clientWidth) - 1;

    this.trackTarget.scrollTo({
      left: index * clientWidth,
      behavior: "smooth",
    });
  }
}
